import React from 'react'
import useResizeObserver from "../hooks/useResizeObserver";
import notifyParent from "../helpers/notifyParent";

const withResizeObserver = (Component, pageName) => props => {
  const notifyResize = payload => {
    notifyParent('pageResize', [pageName, payload])
  }

  useResizeObserver(document.querySelector('body'), notifyResize)

  return <Component {...props} />
}

export default withResizeObserver